import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from "lodash";
import swal from 'sweetalert2';
import axios from "axios/index";
import {withRouter} from 'react-router-dom';
import InputMask from 'react-input-mask';

import urls from "../../../../utils/urls";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import validators from "../../../../utils/validators";
import translator from "../../../../utils/translations";
import { Spinner } from '../../../../components/Loading/Spinner';
import Datepicker from '../../../../components/Datepicker/datepicker';
import { reloadTrip } from '../../../../actions/trip_actions';
import formatter from "../../../../utils/formatters";
import PlateInput from "../../../../components/PlateInput/plateInput";
import helpers from "../../../../utils/helpers";


class TripDispatch extends Component {

    constructor(props) {
        super(props);

        let {trip} = props;

        this.state = {
            ajaxInProgress: false,
            trip: this.props.trip,
            products: false,
            terminals: false,
            providers: false,
            product: trip.product.id,
            provider: trip.provider.id,
            terminal: trip.terminal.id,
            load_datetime: trip.load_datetime,
            provider_load_volume: trip.provider_load_volume,
            provider_trip_receipt: trip.provider_trip_receipt,
            provider_observations: trip.provider_observations,
            carrier: trip.carrier,
            driver_name: trip.driver_name,
            driver_doc: trip.driver_doc,
            truck_plate: trip.truck_plate,
            trailer_plate: trip.trailer_plate
        }
    }

    componentDidMount() {
        this._fetchOptions();
    }

    _initializeHtml = () => {
        window.initializeSelects('body');
        window.bindSelectAction(this.terminalSelect, this._handleSelectChange);
        window.bindSelectAction(this.productSelect, this._handleSelectChange);
    };

    _fetchOptions = () => {
        const provider = `${urls.API_ROOT}/api/v1/provider/`;
        const terminal = `${urls.API_ROOT}/api/v1/terminal/`;
        const product = `${urls.API_ROOT}/api/v1/product/`;
        axios.all([
            axios.get(provider, tokenHeader()),
            axios.get(terminal, tokenHeader()),
            axios.get(product, tokenHeader()),
        ])
            .then(axios.spread(function (prov, terminal, prod) {
                return {
                    providers: prov,
                    terminals: terminal,
                    products: prod,
                }
            }))
            .then((data) => {
                this.setState({
                    providers: data.providers.data,
                    terminals: data.terminals.data,
                    products: data.products.data.filter(p => p.trip_type === helpers.trip_type.FE),
                }, this._initializeHtml)
            })
            .catch((error) => ajaxHandler(error))
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        let prop = target.getAttribute('data-state-var');
        this.setState({[prop]: target.value});
    };

    _handleInput = (prop, value) => {

        // Custom validations
        if(prop === 'carrier_doc'){
            value = validators.cuit(value);
        }

        let numbers = ['provider_load_volume'];
        if(numbers.indexOf(prop) > -1){
            value = validators.number(value);
        }

        this.setState({[prop]: value});
    };

    _handleDateChange = (prop, value) => {
        this.setState({[prop]: value });
    };

    _submitForm = () => {

        this.setState({ajaxInProgress: true});

        let {product, terminal, carrier, driver_name, driver_doc, truck_plate, trailer_plate,
            load_datetime, provider_load_volume, provider_trip_receipt, provider_observations} = this.state;

        let data = {
            next_status: this.props.next_status,
            load_datetime,
            provider_load_volume,
            provider_trip_receipt,
            provider_observations,
            product,
            terminal,
            carrier,
            driver_name,
            driver_doc,
            truck_plate,
            trailer_plate
        };

        const SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.trip.id}/`;
        axios.put(`${SHIPMENT_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Viaje actualizado',
            html: 'El viaje ha sido modificado correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido actualizar el viaje',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };


    render() {
        // Waiting for options
        if(!this.state.products || !this.state.terminals || !this.state.providers){
            return (
                <div className={"valign-wrapper w100"} style={{height: '100%', minHeight: '300px'}}>
                    <Spinner />
                </div>
            );
        }

        let provider_name = '';
        if(this.state.providers){
            let provider = this.state.providers.find(p => p.id === this.state.provider);
            if(provider)provider_name = provider.business_name;
        }

        let loadVolumeLabel = 'Cantidad cargada';
        if(this.state.product && this.state.products){
            let product = this.state.products.find(p => p.id === parseInt(this.state.product, 10));
            if(product){
                loadVolumeLabel = `${_.capitalize(product.origin_unit_of_measure)}. cargados ${product.origin_density ? ` a ${formatter.floatFormat(product.origin_density)}º` : ""}`;
            }
        }

        return (
            <div className={"trip-section"}>
                <div className={"trip-section-title"}>Información del viaje</div>
                <div className={"row no-padding thin-row trip-form"}>
                    <div className={"col s6 no-padding"}>
                        <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                            <h4 className={'table-subtitle'}>Información Orden</h4>
                        </div>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field disabled"}>
                                <label className="active">Proveedor</label>
                                <p className={"field-p truncate"}>{provider_name}</p>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Producto</label>
                                <select defaultValue={this.state.product}
                                        data-state-var="product"  ref={ref => {this.productSelect = ref}}>
                                    <option value="">Seleccione producto</option>
                                    {this.state.products && this.state.products.map(product => {
                                        return <option key={product.id} id={product.id}
                                                       value={product.id}>{product.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Tipo de viaje</label>
                                <p className={"field-p"}>Viaje CIF</p>
                            </div>
                            <div className={"col s6 input-field"}>
                                <label className="active">Destino</label>
                                <select defaultValue={this.state.terminal}
                                        data-state-var="terminal"  ref={ref => {this.terminalSelect = ref}}>
                                    <option value="">Seleccione destino</option>
                                    {this.state.terminals && this.state.terminals.map(terminal => {
                                        return <option key={terminal.id} id={terminal.id}
                                                       value={terminal.id}>{terminal.name}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className={"row thin-row"}>
                            <div className={"col s6 input-field "}>
                                <label className="active">Fecha de Carga</label>
                                <Datepicker classname="input-grey" placeholder={"Ingrese fecha"}
                                            value={this.state.load_datetime} format={"YYYY-MM-DDTh:mm"}
                                            id="load_datetime" action={this._handleDateChange} />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">{loadVolumeLabel}</label>
                                <input placeholder={"Ingrese cantidad"} value={this.state.provider_load_volume}
                                       onChange={(ev) => this._handleInput('provider_load_volume', ev.target.value)}/>
                            </div>
                        </div>
                    </div>
                    <div className={"col s6 no-padding"}>
                        <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                            <h4 className={'table-subtitle'}>Información Transporte</h4>
                        </div>
                        <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                            <div className={"row margin-top-10"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Empresa Transportista</label>
                                    <input placeholder={"Ingrese empresa"} value={this.state.carrier}
                                           onChange={(ev) => this._handleInput('carrier', ev.target.value)}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Nro. Remito</label>
                                    <InputMask placeholder={"Ingrese nro remito"} value={this.state.provider_trip_receipt}
                                               mask={'9999-99999999'}
                                               onChange={(ev) => this._handleInput('provider_trip_receipt', ev.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={"row margin-top-10"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Chofer - Nombre y Apellido</label>
                                    <input placeholder={"Ingrese nombre del chofer"} value={this.state.driver_name}
                                           onChange={(ev) => this._handleInput('driver_name', ev.target.value)}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Licencia de Conducir</label>
                                    <input placeholder={"Ingrese licencia"} value={this.state.driver_doc}
                                           onChange={(ev) => this._handleInput('driver_doc', ev.target.value)}/>
                                </div>
                            </div>
                            <div className={"row thin-row"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Patente Chasis</label>
                                    <PlateInput
                                        placeholder="Ingrese patente del chasis" value={this.state.truck_plate}
                                        action={this._handleInput} name={'truck_plate'}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Patente Acoplado</label>
                                    <PlateInput
                                        placeholder="Ingrese patente del acoplado" value={this.state.trailer_plate}
                                        action={this._handleInput} name={'trailer_plate'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"col s12 input-field input-grey"}>
                        <label className="active">Observaciones</label>
                        <input placeholder={"Ingrese las observaciones del viaje"} value={this.state.provider_observations}
                               onChange={(ev) => this._handleInput('provider_observations', ev.target.value)}/>
                    </div>
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${this.state.ajaxInProgress ? 'disabled' : ''}`}>
                            Actualizar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({reloadTrip}, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TripDispatch));



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripProviderForm.js